import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from "react-lazy-load-image-component";
// import { ourTeamPageData } from "../../common";
import { Col, Container, Row } from "reactstrap";
// core components
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import AboutUsBanner from "../../components/AboutUs/AboutUsBanner";
import YourIdea from "../../components/AboutUs/YourIdea";
import CustomerReviews from "../../components/CustomerReviews/CustomerReviews";
import OurLatestBlogs from "../../components/OurLatestBlogs/OurLatestBlogs";
import ContactUsComponent from "../../components/ContactUsComponent/ContactUsComponent";
// import ellipseImageTop from '../../assets/images/landingpage/Ellipse1880.avif'
// import ellipseImageBottom from '../../assets/images/landingpage/Ellipse1879.avif'
import { getIPGeoLocation } from "../../common/GeneralUtils";
// import { Link } from "react-router-dom";
import axios from "axios";
// import * as Icons from '../../common/icons/ourTeamPageDataIcons';
import Toasts from "../../components/Toasts/Toasts";
// import Loadable from "../../components/Loadable"

// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )
// const Footer = Loadable(
//     lazy(() => import('../../components/footer/footer'))
// )
// const AboutUsBanner = Loadable(
//     lazy(() => import('../../components/AboutUs/AboutUsBanner'))
// )
// const YourIdea = Loadable(
//     lazy(() => import('../../components/AboutUs/YourIdea'))
// )
// const CustomerReviews = Loadable(
//     lazy(() => import('../../components/CustomerReviews/CustomerReviews'))
// )
// const OurLatestBlogs = Loadable(
//     lazy(() => import('../../components/OurLatestBlogs/OurLatestBlogs'))
// )
// const ContactUsComponent = Loadable(
//     lazy(() => import('../../components/ContactUsComponent/ContactUsComponent'))
// )
// const ellipseImageTop = Loadable(
//     lazy(() => import('../../assets/images/landingpage/Ellipse1880.avif'))
// )
// const ellipseImageBottom = Loadable(
//     lazy(() => import('../../assets/images/landingpage/Ellipse1879.avif'))
// )


const OurTeamScreen = () => {
    const [toasts, setToasts] = useState(null)
    const [ourTeamPageData, setData] = useState({});

    const getAllOurTeamPageData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/ourTeamPageData.json');
            setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }
    useEffect(() => {
        getAllOurTeamPageData()
        getIPGeoLocation()
    }, [])
    return (
        <div id="main-wrapper">
            <Header />
            <div className="page-wrapper ourTeam-page-wrapper">
                <div className="container-fluid">
                    <div className="page-content-top">
                        <AboutUsBanner bannerImg={ourTeamPageData?.bannerImg} data={ourTeamPageData?.headerData} />
                        <div className="content-tech-page-warper acss-1kbtli">
                            <div className='position-absolute' style={{ inset: 0 }}>
                                <div className="acss-lbif7z acss-b61x89">
                                    <img rel="preload" className="acss-61n50j acss-118odl4" src={'/assets/images/landingpage/Ellipse1880.avif'} alt="ellipseImage" />
                                    <img rel="preload" className="acss-61n50j acss-x14t9p" src={'/assets/images/landingpage/Ellipse1879.avif'} alt="img" />
                                </div>
                                <div className="acss-lbif7z acss-wom5xg">
                                    <img rel="preload" className="acss-61n50j acss-1ptcy1b" src={'/assets/images/landingpage/Ellipse1880.avif'} alt="img" />
                                    <img rel="preload" className="acss-61n50j acss-1ht8015" src={'/assets/images/landingpage/Ellipse1879.avif'} alt="img" />
                                </div>
                                <div></div>
                            </div>
                            <Container className="acss-18azjcp">
                                <div className="page-context-text">
                                    <h1>{ourTeamPageData?.aboutText?.title}</h1>
                                    {ourTeamPageData?.aboutText?.textData.map((text, index) => <p key={index}>{text?.paragraph}</p>)}
                                </div>

                                {ourTeamPageData?.ourTeamData?.map((tech, index) => {
                                    const isOdd = index % 2 !== 0; // Check if the index is odd
                                    return (
                                        isOdd ? (
                                            <Row key={index} className="my-5">
                                                <Col lg={6} md={6} className="m-auto text-start">
                                                    <LazyLoadImage
                                                        alt={'image'}
                                                        className="w-100"
                                                        // height={image.height}
                                                        src={tech?.pageImg} // use normal <img> attributes as props
                                                    // width={image.width}
                                                    />
                                                    {/* <img src={tech?.pageImg} alt="img" /> */}
                                                </Col>
                                                <Col className="tech-page-warper " lg={6} md={6}>
                                                    <h1>{tech?.title}</h1>
                                                    <p>{tech?.position}</p>
                                                    {tech?.paragraph.map((text, index) => <p key={index} className="par-text">{text?.text}</p>)}
                                                    {tech?.techImg && <LazyLoadImage
                                                        alt={'image'}
                                                        className="w-100"
                                                        // height={image.height}
                                                        src={tech?.techImg} // use normal <img> attributes as props
                                                    // width={image.width}
                                                    />}
                                                </Col>
                                                <Col lg={12} md={12} className="m-auto text-start">
                                                    {tech?.paragraph1?.map((text, index) => <p key={index} className="par-text">{text?.text}</p>)}
                                                </Col>
                                            </Row>
                                        ) : (
                                            <Row key={index} className="my-5">
                                                <Col className="tech-page-warper" lg={6} md={6}>
                                                    <h1>{tech?.title}</h1>
                                                    <p>{tech?.position}</p>
                                                    {tech?.paragraph.map((text, index) => <p key={index} className="par-text">{text?.text}</p>)}
                                                    {tech?.techImg && <LazyLoadImage
                                                        alt={'image'}
                                                        className="w-100 my-5"
                                                        // height={image.height}
                                                        src={tech?.techImg} // use normal <img> attributes as props
                                                    // width={image.width}
                                                    />}
                                                </Col>
                                                <Col lg={6} md={6} className="m-auto text-end">
                                                    <LazyLoadImage
                                                        alt={'image'}
                                                        className="w-100"
                                                        // height={image.height}
                                                        src={tech?.pageImg} // use normal <img> attributes as props
                                                    // width={image.width}
                                                    />
                                                    {/* <img src={tech?.pageImg} alt="img" /> */}
                                                </Col>
                                                <Col lg={12} md={12} className="m-auto text-start mt-5">
                                                    {tech?.paragraph1?.map((text, index) => <p key={index} className="par-text">{text?.text}</p>)}
                                                </Col>
                                            </Row>
                                        )
                                    )
                                })}

                            </Container>
                        </div>
                        <div className="special-technologies">
                            <YourIdea data={ourTeamPageData?.yourIdea} />
                        </div>
                        <CustomerReviews />
                        <OurLatestBlogs />
                        <div className="home-contact-page">
                            <ContactUsComponent setToasts={setToasts} />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
            {toasts && <Toasts toastsList={toasts} />}
        </div>
    );
}

OurTeamScreen.propTypes = {
    classes: PropTypes.object
};

export default OurTeamScreen;
